import { render, staticRenderFns } from "./InvoiceInformationList.vue?vue&type=template&id=3b398ab1"
import script from "./InvoiceInformationList.vue?vue&type=script&lang=js"
export * from "./InvoiceInformationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports